import { getCollectionFields } from '../pluginComponentApi';
export default (editor, opts) => {
  const dc = editor.DomComponents;
  const { type, label, projectId, collections, pageCollection, version } = opts;
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  let options = [{ value: '', name: '- Select Collection -', disabled: true }];
  collections.forEach((item) => {
    options.push({ value: item.collectionName, name: item.collectionTitle });
  });

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label,
          projectId: projectId,
          droppable: false, // Can't drop other elements inside
          icon: '<i class="wb webconnect-calendar2-plus"></i>',
          collectionName: '',
          collectionFrom: '',
          finderUuid: '',
          traits: [
            {
              type: 'data-calendar-timeslot-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            ...dc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            if (typeof loadTimeslotComponent !== 'undefined') {
              console.log('*** Loading Timeslot script...');
              const collectionId = '{[ collectionName ]}';
              const finderId = '{[ finderUuid ]}';
              const collectionFrom = '{[ collectionFrom ]}';
              const timeSlotMetaFieldFrom = '{[ data-timeslot-meta-field-from ]}';
              const timeSlotMetaFieldCollectionName = '{[ data-meta-field-page-collection ]}';

              let timeslotDataObj = {};
              timeslotDataObj.collectionName = collectionId;
              timeslotDataObj.finderId = finderId;
              timeslotDataObj.collectionFrom = collectionFrom;
              timeslotDataObj.timeSlotMetaFieldFrom = timeSlotMetaFieldFrom;
              timeslotDataObj.timeSlotMetaFieldCollectionName = timeSlotMetaFieldCollectionName;
              loadTimeslotComponent(this, timeslotDataObj);
            }
          },
        },
        init() {
          const collectionName = this.get('collectionName');
          const timeslotFieldValue = this.get('data-timeslot-meta-field-from');
          const timeslotFieldTrait = this.getTrait('timeslotMetaFieldFrom');
          if (collectionName && !timeslotFieldTrait) {
            this.addTrait(
              {
                type: 'data-timeslot-field',
                label: false,
                name: 'timeslotMetaFieldFrom',
                customLabel: 'Get Value From',
                content: false,
                changeProp: 1,
              },
              { at: this.getTraitIndex('title') + 1 },
            );
          }
          const attr = this.getAttributes();
          if (collectionName && timeslotFieldValue === 'staticValue') {
            let dayStartAt = this.get('data-fixed-day-start-at');
            if (!dayStartAt) {
              dayStartAt = attr['data-fixed-day-start-at'];
            }
            let dayEndAt = this.get('data-fixed-day-end-at');
            if (!dayEndAt) {
              dayEndAt = attr['data-fixed-day-end-at'];
            }
            const dayStartAtTrait = this.getTrait('data-fixed-day-start-at');
            if (!dayStartAtTrait) {
              this.addTrait(
                {
                  type: 'number',
                  label: 'Day Start At (in 24hrs)',
                  name: 'data-fixed-day-start-at',
                  min: 0,
                  step: 1,
                  max: 12,
                  placeholder: 'Default: 10',
                },
                { at: this.getTraitIndex('title') + 2 },
              );
            } else {
              this.set('data-fixed-day-start-at', dayStartAt);
            }
            const dayEndAtTrait = this.getTrait('data-fixed-day-end-at');
            if (!dayEndAtTrait) {
              this.addTrait(
                {
                  type: 'number',
                  label: 'Day End At (in 24hrs)',
                  name: 'data-fixed-day-end-at',
                  min: 13,
                  step: 1,
                  max: 24,
                  placeholder: 'Default: 20',
                },
                { at: this.getTraitIndex('title') + 3 },
              );
            } else {
              this.set('data-fixed-day-end-at', dayEndAt);
            }
          } else if (collectionName) {
            this.removeTrait('data-fixed-day-start-at');
            this.removeTrait('data-fixed-day-end-at');
          }

          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:timeslotMetaFieldFrom', this.handleTimeSlotMetaFieldFromChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collectionResponse = await getCollectionFields(collectionName, collections);
          if (collectionResponse) {
            this.removeTrait('timeslotMetaFieldFrom');
            this.removeTrait('data-event-starttime');
            this.removeTrait('data-event-endtime');
            this.removeTrait('data-event-duration');
            this.removeTrait('data-timeslot-format');
            this.removeTrait('data-fixed-day-start-at');
            this.removeTrait('data-fixed-day-end-at');
            this.addTrait(
              {
                type: 'data-timeslot-field',
                label: false,
                name: 'timeslotMetaFieldFrom',
                customLabel: 'Get Value From',
                content: false,
                changeProp: 1,
              },
              { at: this.getTraitIndex('title') + 1 },
            );
          } else {
            this.removeTrait('timeslotMetaFieldFrom');
            this.removeTrait('data-event-starttime');
            this.removeTrait('data-event-endtime');
            this.removeTrait('data-event-duration');
            this.removeTrait('data-timeslot-format');
            this.removeTrait('data-fixed-day-start-at');
            this.removeTrait('data-fixed-day-end-at');
          }
        },
        async handleTimeSlotMetaFieldFromChange() {
          const collectionName = this.get('collectionName');
          const timeslotMetaFieldFrom = this.get('timeslotMetaFieldFrom');
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView,
  });
};
